import { render, staticRenderFns } from "./NewChatHistoryContacts.vue?vue&type=template&id=71728232"
import script from "./NewChatHistoryContacts.vue?vue&type=script&lang=js"
export * from "./NewChatHistoryContacts.vue?vue&type=script&lang=js"
import style0 from "./NewChatHistoryContacts.vue?vue&type=style&index=0&id=71728232&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports